import { PropsWithChildren } from 'react';

import { createNativeChatUrl } from 'shared/utils/url';

import { InboxContext, InboxModalOptions } from './InboxContext';

export const InboxProvider = ({ children }: PropsWithChildren<unknown>) => {
  const onOpenInboxModal = (data: InboxModalOptions) => {
    const [member] = data.options?.members ?? [];

    if (!member?.id) {
      return;
    }

    const target = data.options?.messageType === 'group' ? 'group' : 'user';

    window.location.assign(createNativeChatUrl(target, member.id));
  };

  return <InboxContext.Provider value={{ onOpenInboxModal }}>{children}</InboxContext.Provider>;
};
